/* Super Loops theme — vanilla JS, no dependencies. */
(function () {
  'use strict';

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var value = (cents / 100);
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var out;
    switch (key) {
      case 'amount_no_decimals': out = Math.round(value).toLocaleString('en-US'); break;
      case 'amount_with_comma_separator': out = value.toFixed(2).replace('.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = Math.round(value).toLocaleString('de-DE'); break;
      default: out = value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function parseNotes(str) {
    var map = [];
    (str || '').split(/\n/).forEach(function (line) {
      var parts = line.split('|');
      if (parts.length >= 2) map.push({ key: parts[0].trim().toLowerCase(), text: parts.slice(1).join('|').trim() });
    });
    return map;
  }
  function findNote(map, value) {
    var v = (value || '').toLowerCase();
    for (var i = 0; i < map.length; i++) if (map[i].key === v) return map[i].text;
    for (var j = 0; j < map.length; j++) if (map[j].key && (v.indexOf(map[j].key) > -1 || map[j].key.indexOf(v) > -1)) return map[j].text;
    return '';
  }
  function flavorKey(name) {
    var n = (name || '').toLowerCase();
    if (/variety|all three|mixed/.test(n)) return 'variety';
    if (/blue|rasp/.test(n)) return 'blu';
    if (/straw|lemon/.test(n)) return 'stw';
    if (/water|melon/.test(n)) return 'wtm';
    return 'default';
  }
  function unitsIn(value) {
    var m = (value || '').match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  }

  /* ---------- Cart count ---------- */
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  /* ---------- Slide-out cart drawer ---------- */
  var Drawer = (function () {
    var el, cfg = {}, lastFocus;
    function q(sel) { return el ? el.querySelector(sel) : null; }
    function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
    function root() { return cfg.root || '/'; }
    function render(cart) {
      setCartCount(cart.item_count);
      var items = q('[data-drawer-items]');
      if (!items) return;
      if (!cart.items.length) {
        items.innerHTML = '<p class="sl-drawer__empty">Your cart is empty.</p>';
      } else {
        items.innerHTML = cart.items.map(function (it, i) {
          var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2') : '';
          var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="sl-drawer__variant">' + esc(it.variant_title) + '</div>' : '';
          return '<div class="sl-drawer__item" data-line="' + (i + 1) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="' + esc(it.product_title) + '" loading="lazy" width="76" height="76">' : '<span></span>') +
            '<div><a class="sl-drawer__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
            '<div class="sl-drawer__qty"><button type="button" data-line-step="-1" aria-label="Decrease quantity">&minus;</button><span>' + it.quantity + '</span><button type="button" data-line-step="1" aria-label="Increase quantity">+</button></div></div>' +
            '<div class="sl-drawer__price">' + formatMoney(it.final_line_price, cfg.money_format) +
            '<button type="button" class="sl-drawer__remove" data-line-remove>Remove</button></div></div>';
        }).join('');
      }
      var sub = q('[data-drawer-subtotal]'); if (sub) sub.textContent = formatMoney(cart.total_price, cfg.money_format);
      var co = q('[data-drawer-checkout]'); if (co) co.hidden = !cart.items.length;
      var th = cfg.threshold || 0, msg = q('[data-drawer-ship-msg]'), fill = q('[data-drawer-ship-fill]');
      if (th > 0 && msg && fill) {
        var left = th - cart.total_price;
        msg.textContent = left > 0 ? 'You’re ' + formatMoney(left, cfg.money_format) + ' away from free shipping' : 'You unlocked free shipping!';
        fill.style.width = Math.min(100, Math.round(cart.total_price / th * 100)) + '%';
      }
    }
    function refresh() { return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; }); }
    function change(line, qty) {
      el.setAttribute('aria-busy', 'true');
      return fetch(root() + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(render)
        .finally(function () { el.removeAttribute('aria-busy'); });
    }
    function open(added) {
      if (!el) return false;
      lastFocus = document.activeElement;
      var a = q('[data-drawer-added]'); if (a) a.hidden = !added;
      el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sl-drawer-open');
      var p = q('.sl-drawer__panel'); if (p) setTimeout(function () { p.focus(); }, 50);
      return true;
    }
    function close() {
      if (!el) return;
      el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sl-drawer-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function init() {
      el = document.querySelector('[data-cart-drawer]');
      if (!el || el.__init) return;
      el.__init = true;
      try { cfg = JSON.parse(q('[data-drawer-config]').textContent); } catch (e) { cfg = {}; }
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); close(); return; }
        var row = e.target.closest('[data-line]'); if (!row) return;
        var line = parseInt(row.getAttribute('data-line'), 10);
        var qty = parseInt(row.querySelector('.sl-drawer__qty span').textContent, 10) || 0;
        var step = e.target.closest('[data-line-step]');
        if (step) change(line, Math.max(0, qty + parseInt(step.getAttribute('data-line-step'), 10)));
        if (e.target.closest('[data-line-remove]')) change(line, 0);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-open')) close(); });
      // Header cart buttons open the drawer instead of leaving the page
      document.querySelectorAll('a[href$="/cart"]').forEach(function (a) {
        if (!a.closest('.sl-header') || a.closest('[data-cart-drawer]')) return;
        a.addEventListener('click', function (e) { e.preventDefault(); refresh(); open(false); });
      });
      // Simple product forms (e.g. landing-page offer cards) add without leaving the page
      document.querySelectorAll('form.sl-offer__form').forEach(function (f) {
        f.addEventListener('submit', function (e) {
          e.preventDefault();
          var b = f.querySelector('[type="submit"]'); if (b) b.setAttribute('aria-busy', 'true');
          addToCart(new FormData(f)).catch(function () { f.submit(); })
            .finally(function () { if (b) b.removeAttribute('aria-busy'); });
        });
      });
    }
    return { init: init, open: open, refresh: refresh, available: function () { return !!el; } };
  })();

  function addToCart(formData) {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Accept': 'application/json' }, body: formData
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart.');
        return Drawer.refresh().then(function () {
          if (!Drawer.open(true)) toast('Added to cart <a class="sl-btn sl-btn--sm" href="/cart">View cart</a>');
        });
      });
  }



  /* ---------- Judge.me review feed (home / landing) ---------- */
  function initReviewFeed() {
    document.querySelectorAll('[data-jdgm-feed]').forEach(function (box) {
      if (box.__init) return; box.__init = true;
      var handles = (box.getAttribute('data-handles') || '').split(',').filter(Boolean);
      var SET = 3, ROTATE_MS = 7000;
      var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
      function byBest(a, b) { return (b.stars - a.stars) || (b.date || '').localeCompare(a.date || ''); }
      function card(r) {
        var stars = ''; for (var i = 1; i <= 5; i++) stars += i <= r.stars ? '★' : '☆';
        return '<div class="sl-review-card"><span class="sl-stars" aria-label="' + r.stars + ' out of 5 stars">' + stars + '</span>' +
          '<p>“' + esc(r.body) + '”</p>' +
          '<span class="sl-attrib' + (r.verified ? ' sl-verified' : '') + '">' + (r.verified ? 'Verified buyer' : esc(r.name)) + '</span>' +
          (r.product ? '<span class="sl-review-card__product">' + esc(r.product) + '</span>' : '') + '</div>';
      }
      Promise.all(handles.map(function (h) {
        return fetch(root + 'products/' + h).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var title = ((doc.querySelector('meta[property="og:title"]') || {}).content || '').replace(/\s*[–-]\s*Actually Fruit\s*$/, '');
          var seenR = {};
          var reviews = Array.prototype.map.call(doc.querySelectorAll('.jdgm-rev'), function (r) {
            var body = r.querySelector('.jdgm-rev__body'); var who = r.querySelector('.jdgm-rev__author');
            var ts = r.querySelector('.jdgm-rev__timestamp'); var sc = r.querySelector('.jdgm-rev__rating');
            return { body: body ? body.textContent.trim() : '', name: who ? who.textContent.trim() : '',
              date: ts ? (ts.getAttribute('data-content') || '') : '', stars: sc ? parseInt(sc.getAttribute('data-score'), 10) || 5 : 5,
              verified: !!r.querySelector('.jdgm-rev__buyer-badge'), product: title };
          }).filter(function (r) { var k = r.name + '|' + r.body; if (!r.body || seenR[k]) return false; seenR[k] = true; return true; });
          return { handle: h, title: title, url: root + 'products/' + h, reviews: reviews.sort(byBest) };
        }).catch(function () { return { handle: h, title: '', url: root + 'products/' + h, reviews: [] }; });
      })).then(function (groups) {
        var all = [].concat.apply([], groups.map(function (g) { return g.reviews; })).sort(byBest);
        if (!all.length) return;
        /* Highlights: one review per person (their best), highest-rated first, rotating 3 at a time */
        var seen = {}, pool = all.filter(function (r) { var k = (r.name.split(/\s+/)[0] || '').toLowerCase(); if (seen[k]) return false; seen[k] = true; return true; });
        var sets = []; for (var i = 0; i < pool.length; i += SET) sets.push(pool.slice(i, i + SET));
        if (sets.length > 1 && sets[sets.length - 1].length < SET) { /* top up the last set from the top so it always shows 3 */
          var last = sets[sets.length - 1]; for (var t = 0; last.length < SET && t < pool.length; t++) if (last.indexOf(pool[t]) < 0) last.push(pool[t]);
        }
        var cur = 0, timer = null, paused = false;
        var dots = document.createElement('div'); dots.className = 'sl-review-dots';
        if (sets.length > 1) dots.innerHTML = sets.map(function (_, n) { return '<button type="button" aria-label="Show reviews set ' + (n + 1) + '"></button>'; }).join('');
        function show(n) {
          cur = (n + sets.length) % sets.length;
          box.classList.add('is-fading');
          setTimeout(function () {
            box.innerHTML = sets[cur].map(card).join('');
            box.classList.remove('is-fading');
            Array.prototype.forEach.call(dots.children, function (d, k) { d.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
          }, box.__shown ? 250 : 0);
          box.__shown = true;
        }
        function start() { if (sets.length < 2 || reduce) return; clearInterval(timer); timer = setInterval(function () { if (!paused && !document.hidden) show(cur + 1); }, ROTATE_MS); }
        dots.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; show(Array.prototype.indexOf.call(dots.children, b)); start(); });
        box.addEventListener('mouseenter', function () { paused = true; }); box.addEventListener('mouseleave', function () { paused = false; });
        show(0); box.hidden = false; start();
        /* Arrived from a "Write a review" button (/#reviews): land on this section once the cards have loaded */
        if (location.hash === '#reviews') {
          setTimeout(function () {
            var sec = document.getElementById('reviews'); if (sec) window.scrollTo({ top: sec.getBoundingClientRect().top + window.scrollY - 80, behavior: 'instant' });
            if (window.history.replaceState) window.history.replaceState(null, '', location.pathname + location.search);
          }, 60);
        }

        /* "See all reviews" — every review, filterable by flavor */
        var wrap = document.createElement('div'); wrap.className = 'sl-review-all';
        var tabs = [{ key: 'all', label: 'All flavors', list: all }].concat(groups.filter(function (g) { return g.title; }).map(function (g) { return { key: g.handle, label: g.title, list: g.reviews, url: g.url }; }));
        wrap.innerHTML = '<button type="button" class="sl-btn sl-btn--sm sl-btn--light sl-review-all__toggle" aria-expanded="false">See all reviews (' + all.length + ')</button>' +
          '<div class="sl-review-all__panel" hidden><div class="sl-review-all__tabs" role="tablist">' +
          tabs.map(function (t, n) { return '<button type="button" role="tab" data-k="' + n + '" aria-selected="' + (n === 0) + '">' + esc(t.label) + ' <span>(' + t.list.length + ')</span></button>'; }).join('') +
          '</div><div class="sl-grid sl-grid--3 sl-review-all__list"></div></div>';
        if (sets.length > 1) box.insertAdjacentElement('afterend', dots);
        (sets.length > 1 ? dots : box).insertAdjacentElement('afterend', wrap);
        var toggle = wrap.querySelector('.sl-review-all__toggle'), panel = wrap.querySelector('.sl-review-all__panel'), list = wrap.querySelector('.sl-review-all__list');
        function pick(n) {
          var t = tabs[n];
          Array.prototype.forEach.call(wrap.querySelectorAll('[role="tab"]'), function (b, k) { b.setAttribute('aria-selected', k === n ? 'true' : 'false'); });
          list.innerHTML = t.list.length ? t.list.map(card).join('') :
            '<p class="sl-review-all__empty">No reviews for ' + esc(t.label) + ' yet. <a href="' + t.url + '#write-review">Be the first to write one</a>.</p>';
        }
        toggle.addEventListener('click', function () {
          var open = panel.hidden; panel.hidden = !open; toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          toggle.textContent = open ? 'Hide reviews' : 'See all reviews (' + all.length + ')';
          paused = open;
          if (open) { pick(0); panel.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' }); }
        });
        wrap.querySelector('.sl-review-all__tabs').addEventListener('click', function (e) { var b = e.target.closest('[role="tab"]'); if (b) pick(+b.getAttribute('data-k')); });
      });
    });
  }

  /* ---------- Open the Judge.me review form when arriving via #write-review ---------- */
  function initWriteReviewLink() {
    var pagePath = location.pathname; /* the product whose Judge.me widget is on this page */
    function openForm() {
      var tries = 0;
      /* Clean the address bar so a refresh shows the normal page, not the review form again */
      try {
        var u = new URL(window.location.href); u.searchParams.delete('review'); u.hash = '';
        if (window.history.replaceState) window.history.replaceState(null, '', u.pathname + u.search);
      } catch (err) {}
      (function look() {
        var btn = Array.prototype.find.call(document.querySelectorAll('#reviews button, #reviews a'), function (el) { return /write a review/i.test(el.textContent) && !el.classList.contains('sl-pill--reviews'); });
        if (btn) { btn.scrollIntoView({ block: 'center' }); btn.click(); return; }
        if (++tries < 40) setTimeout(look, 250);
      })();
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href$="#write-review"]');
      if (!a) return;
      e.preventDefault();
      if (a.pathname === pagePath) openForm();
      else window.location.href = a.pathname + '?review=1#write-review'; /* full page load so the right flavor's form opens */
    });
    if (location.hash === '#write-review') openForm();
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(html) {
    var t = document.querySelector('[data-toast]');
    if (!t) {
      t = document.createElement('div');
      t.className = 'sl-toast';
      t.setAttribute('data-toast', '');
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.innerHTML = html;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 3800);
  }

  /* ---------- Product (buy box) ---------- */
  function initProduct(root) {
    if (root.dataset.slInit) return;
    root.dataset.slInit = '1';
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var variants = data.variants;
    var form = root.querySelector('[data-product-form]');
    var idInput = root.querySelector('[data-variant-input]');
    var optionsWrap = root.querySelector('[data-options]');
    var fieldsets = optionsWrap ? Array.prototype.slice.call(optionsWrap.querySelectorAll('fieldset[data-option-index]')) : [];
    var packNotes = parseNotes(optionsWrap && optionsWrap.getAttribute('data-pack-notes'));
    var flavorNoteEl = root.querySelector('[data-flavor-note]');
    var flavorNotes = parseNotes(flavorNoteEl && flavorNoteEl.getAttribute('data-notes'));
    var unitEl = root.querySelector('[data-unit-note]');
    var bagSize = unitEl ? unitEl.getAttribute('data-bag-size') : '';
    var sticky = root.querySelector('[data-sticky-atc]');

    // Pack tile subtitles
    fieldsets.forEach(function (fs) {
      if (fs.getAttribute('data-kind') !== 'pack') return;
      fs.querySelectorAll('.sl-choice').forEach(function (label) {
        var sub = label.querySelector('[data-pack-sub]');
        if (sub) sub.textContent = findNote(packNotes, label.getAttribute('data-value'));
      });
    });

    function selected() {
      return fieldsets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function matches(v, sel, upto) {
      for (var i = 0; i < upto; i++) if (sel[i] !== null && v.options[i] !== sel[i]) return false;
      return true;
    }

    // Hide option groups that collapse to a single value for the current earlier selections
    // (e.g. "3-Pack Variety" has only Flavor = "Variety" → the flavor row disappears, like the canvas).
    function reconcile() {
      var sel = selected();
      fieldsets.forEach(function (fs, i) {
        if (i === 0) return;
        var possible = {};
        variants.forEach(function (v) { if (matches(v, sel, i)) possible[v.options[i]] = true; });
        var keys = Object.keys(possible);
        fs.querySelectorAll('input').forEach(function (inp) {
          var label = inp.closest('.sl-choice');
          var ok = !!possible[inp.value];
          label.hidden = !ok;
          inp.disabled = !ok;
        });
        var current = fs.querySelector('input:checked');
        if (!current || !possible[current.value]) {
          var first = fs.querySelector('input:not(:disabled)');
          if (first) first.checked = true;
          sel[i] = first ? first.value : null;
        }
        fs.hidden = keys.length <= 1;
      });
      return selected();
    }

    function currentVariant() {
      var sel = reconcile();
      if (!fieldsets.length) return variants[0];
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options.every(function (o, idx) { return sel[idx] === undefined || sel[idx] === null || o === sel[idx]; })) return variants[i];
      }
      return null;
    }

    function showMedia(id) {
      if (!id) return;
      var slides = root.querySelectorAll('.sl-gallery__slide');
      var target = root.querySelector('.sl-gallery__slide[data-media-id="' + id + '"]');
      if (!target) return;
      slides.forEach(function (s) {
        s.classList.toggle('is-active', s === target);
        if (s !== target) { var vid = s.querySelector('video'); if (vid) vid.pause(); }
      });
      root.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', t.getAttribute('data-thumb') === String(id) ? 'true' : 'false');
      });
    }

    function update(fromUser) {
      var v = currentVariant();
      var atc = root.querySelector('[data-atc]');
      var atcLabel = root.querySelector('[data-atc-label]');
      var stickyBtn = root.querySelector('[data-sticky-btn]');
      if (!v) {
        if (atc) atc.disabled = true;
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      if (idInput) idInput.value = v.id;
      var price = formatMoney(v.price, data.money_format);
      var priceEl = root.querySelector('[data-price]');
      if (priceEl) priceEl.textContent = price;
      var cmp = root.querySelector('[data-compare]');
      if (cmp) {
        if (v.compare_at_price > v.price) { cmp.hidden = false; cmp.textContent = formatMoney(v.compare_at_price, data.money_format); }
        else cmp.hidden = true;
      }
      var packVal = data.pack_index !== null ? v.options[data.pack_index] : null;
      var flavorVal = data.flavor_index !== null ? v.options[data.flavor_index] : null;
      if (unitEl) {
        var units = packVal ? unitsIn(packVal) : 1;
        unitEl.textContent = units > 1
          ? units + ' × ' + (bagSize || 'bag') + ' · ' + formatMoney(Math.floor(v.price / units), data.money_format) + ' a bag'
          : (bagSize || '');
      }
      var flavorLine = root.querySelector('[data-flavor-line]');
      if (flavorLine && flavorVal) flavorLine.textContent = /variety/i.test(flavorVal) && !/pack/i.test(flavorVal) ? flavorVal + ' Pack' : flavorVal;
      if (flavorNoteEl) flavorNoteEl.textContent = ' ' + findNote(flavorNotes, flavorVal || v.title);
      if (atc) {
        atc.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? 'Add to cart — ' + price : 'Sold out';
      }
      if (sticky) {
        var key = flavorKey(flavorVal || v.title);
        sticky.className = sticky.className.replace(/sl-grad--\S+/g, '').trim() + ' sl-grad--' + key;
        var sl = sticky.querySelector('[data-sticky-label]');
        var sp = sticky.querySelector('[data-sticky-price]');
        if (sl) sl.textContent = packVal && flavorVal ? (/variety/i.test(flavorVal) ? packVal : packVal + ' · ' + flavorVal) : v.title;
        if (sp) sp.textContent = price;
        if (stickyBtn) stickyBtn.disabled = !v.available;
        var sImg = sticky.querySelector('img[data-sticky-img]');
        if (sImg && v.image) { sImg.src = v.image; sImg.removeAttribute('srcset'); }
      }
      // Flavor-specific gallery: images whose alt text names another flavor hide while this flavor is picked.
      var fkNow = flavorKey(flavorVal || v.title);
      root.querySelectorAll('[data-thumb][data-flavor]').forEach(function (t) {
        var f = t.getAttribute('data-flavor');
        t.hidden = fkNow !== 'variety' && fkNow !== 'default' && f !== 'default' && f !== fkNow;
      });
      root.querySelectorAll('[data-thumb][data-hide-for]').forEach(function (t) {
        var list = (t.getAttribute('data-hide-for') || '').split(/\s+/);
        t.hidden = list.indexOf(fkNow) > -1;
      });
      if (fkNow === 'variety') root.querySelectorAll('[data-thumb][data-variety-hide]').forEach(function (t) { t.hidden = true; });
      // Product family mode: each pack/flavor is its own product, so only that product's images show.
      if (v.member) {
        root.querySelectorAll('[data-thumb][data-member]').forEach(function (t) {
          t.hidden = t.getAttribute('data-member') !== String(v.member);
        });
      }
      if (fromUser) {
        showMedia(v.featured_media_id);
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          if (url.pathname.indexOf('/products/') > -1) {
            if (v.url) window.history.replaceState({}, '', v.url);
            else { url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString()); }
          }
        }
      }
    }

    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', function () { update(true); });
    });

    // Gallery thumbs
    root.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () { showMedia(btn.getAttribute('data-thumb')); });
    });

    // Quantity
    root.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = root.querySelector('[data-qty]');
        var n = Math.min(12, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-step'), 10)));
        input.value = n;
      });
    });

    // AJAX add to cart
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var err = root.querySelector('[data-form-error]');
        var btns = document.querySelectorAll('[data-atc], [data-sticky-btn]');
        btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
        if (err) err.textContent = '';
        var after = root.getAttribute('data-after-add');
        var fd = new FormData(form);
        var p;
        if (after === 'cart') {
          p = fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
            .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart.'); window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; }); });
        } else {
          p = addToCart(fd);
        }
        p
          .catch(function (e2) { if (err) err.textContent = e2.message; })
          .finally(function () { btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
      });
    }

    // Sticky bar: show once the main button scrolls out of view
    var mainAtc = root.querySelector('[data-atc]');
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var sb = sticky.querySelector('[data-sticky-btn]');
        if (sb) sb.tabIndex = show ? 0 : -1;
      }).observe(mainAtc);
    }

    update(false);
  }

  /* ---------- Cart page ---------- */
  function initCart() {
    document.querySelectorAll('[data-cart-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var n = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-step'), 10));
          input.value = n;
          var f = input.form;
          if (f) f.submit();
        });
      });
    });
  }

  /* ---------- UGC videos: play on click ---------- */
  function initUgc() {
    document.querySelectorAll('[data-ugc-play]').forEach(function (btn) {
      if (btn.dataset.slInit) return;
      btn.dataset.slInit = '1';
      btn.addEventListener('click', function () {
        var tile = btn.closest('.sl-ugc__tile');
        var vid = tile.querySelector('video');
        if (!vid) return;
        tile.classList.add('is-playing');
        vid.controls = true;
        vid.muted = false;
        vid.play();
      });
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
      if (btn.dataset.slInit) return;
      btn.dataset.slInit = '1';
      var drawer = document.getElementById(btn.getAttribute('aria-controls'));
      if (!drawer) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) drawer.removeAttribute('open'); else drawer.setAttribute('open', '');
      });
      drawer.addEventListener('click', function (e) {
        if (e.target.closest('a')) { btn.setAttribute('aria-expanded', 'false'); drawer.removeAttribute('open'); }
      });
    });
  }

  /* Keep the hero accent line ("Clean energy.") on one line: shrink it until it fits its column. */
  function fitAccent() {
    document.querySelectorAll('.sl-hero__h1 em').forEach(function (em) {
      em.style.fontSize = '';
      var size = 100;
      while (em.scrollWidth > em.clientWidth + 1 && size > 40) { size -= 4; em.style.fontSize = size + '%'; }
    });
  }
  window.addEventListener('resize', fitAccent);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAccent);

  function init(scope) {
    (scope || document).querySelectorAll('[data-product-root]').forEach(initProduct);
  }

  document.addEventListener('DOMContentLoaded', function () {
    Drawer.init();
    initReviewFeed();
    initWriteReviewLink();
    init();
    fitAccent();
    initCart();
    initUgc();
    initMenu();
  });

  // Theme editor: re-init a section when it reloads
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initUgc(); initMenu(); });
})();
